export default {
  // Shift Actions
  getShifts(start, end) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_SHIFTS,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('START_PARAM')] = start;
    obj.postData[Utils.getEndpointParam('END_PARAM')] = end;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  getAllShifts(start, end) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_ALL_SHIFTS,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('START_PARAM')] = start;
    obj.postData[Utils.getEndpointParam('END_PARAM')] = end;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  getShiftById(id) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_SHIFT_BY_ID,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('SHIFT_ID_PARAM')] = id;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  getShiftByDate(date, endDate) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_SHIFT_BY_DATE,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('START_PARAM')] = date;
    obj.postData[Utils.getEndpointParam('END_PARAM')] = endDate;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  requestShift(id) {
    const obj = {
      actionType: appConstants.ActionTypes.REQUEST_OFFER,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('AVAILABLE_SHIFT_ID')] = id;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
  
  requestShiftWithConflict(id) {
    const obj = {
      actionType: appConstants.ActionTypes.REQUEST_OFFER_WITH_CONFLICT,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('AVAILABLE_SHIFT_ID')] = id;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  cancelRequestedShift(id, shiftID) {
    const obj = {
      actionType: appConstants.ActionTypes.CANCEL_REQUEST_OFFER,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('AVAILABLE_SHIFT_ID')] = id;
    obj.postData.shiftID = shiftID;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  createAvailability(start, end) {
    const obj = {
      actionType: appConstants.ActionTypes.CREATE_AVAILABLE,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('STARTS_AT_PARAM')] = start;
    obj.postData[Utils.getEndpointParam('ENDS_AT_PARAM')] = end;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  deleteAvailability(id) {
    const obj = {
      actionType: appConstants.ActionTypes.DELETE_AVAILABLE,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('SHIFT_ID_PARAM')] = id;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
  deleteRecurringAvailability(shiftId, recurringId, exceptEpoch = 1560967200) {
    const obj = {
      actionType: appConstants.ActionTypes.DELETE_RECURING_AVAILABLE,
      postData: {}
    };
    obj.postData[Utils.getEndpointParam('SHIFT_ID_PARAM')] = shiftId;
    obj.postData[Utils.getEndpointParam('RECURRING_AVAILABILITY_EXCEPT')] = exceptEpoch;
    obj.postData[Utils.getEndpointParam('RECURRING_AVAILABILITY_ID')] = recurringId;

    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  getAvailables(start, end) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_AVAILABLES,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('STARTS_AT_PARAM')] = moment(start).unix();
    obj.postData[Utils.getEndpointParam('ENDS_AT_PARAM')] = moment(end).unix();
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
  getUnavailables(start, end) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_UNAVAILABLES,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('START_PARAM')] = start;
    obj.postData[Utils.getEndpointParam('END_PARAM')] = end;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
  refreshUnavailables(start, end) {
    const obj = {
      actionType: appConstants.ActionTypes.REFRESH_UNAVAILABLES,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('START_PARAM')] = start;
    obj.postData[Utils.getEndpointParam('END_PARAM')] = end;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  getUnavailableTypes() {
    const obj = {
      actionType: appConstants.ActionTypes.GET_UNAVAILABLE_TYPES,
      postData: {},
    };
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  getExchanges(start, end) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_EXCHANGES,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('START_PARAM')] = start;
    obj.postData[Utils.getEndpointParam('END_PARAM')] = end;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  getAllExchanges(start, end) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_ALL_EXCHANGES,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('START_PARAM')] = start;
    obj.postData[Utils.getEndpointParam('END_PARAM')] = end;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  postExchange(shift, drop, notes) {
    if (Utils.isNotDefined(shift)) {
      return;
    }
    const obj = {
      actionType: appConstants.ActionTypes.CREATE_EXCHANGE,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('SHIFT_IDS_PARAM')] = shift;
    obj.postData[Utils.getEndpointParam('DROP_PARAM')] = drop;
    obj.postData[Utils.getEndpointParam('NOTES_PARAM')] = notes;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
  cancelExchange(exchange_id, shift_id) {
    const obj = {
      actionType: appConstants.ActionTypes.CANCEL_EXCHANGE,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('EXCHANGE_ID_PARAM')] = exchange_id;
    obj.postData[Utils.getEndpointParam('SHIFT_ID_PARAM')] = shift_id;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
  postTimeOff(start, end, notes, unavailable_type_id, partial, ignoreConflict) {
    const obj = {
      actionType: appConstants.ActionTypes.CREATE_UNAVAILABLE,
      postData: {},
    };

    if (partial) {
      obj.postData[Utils.getEndpointParam('STARTS_AT_PARAM')] = start;
      obj.postData[Utils.getEndpointParam('ENDS_AT_PARAM')] = end;
    } else {
      obj.postData[Utils.getEndpointParam('START_DATE_PARAM')] = start;
      obj.postData[Utils.getEndpointParam('END_DATE_PARAM')] = end;
    }
    
    obj.postData[Utils.getEndpointParam('NOTES_PARAM')] = notes;
    obj.postData[Utils.getEndpointParam('UNAVAILABLE_PARTIAL_PARAM')] = partial;
    obj.postData[Utils.getEndpointParam('UNAVAILABLE_TYPE_ID_PARAM')] = unavailable_type_id;
    obj.postData.ignore_conflict = ignoreConflict;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
  cancelTimeOffRequest(request_id, timeoff_id) {
    const obj = {
      actionType: appConstants.ActionTypes.CANCEL_TIMEOFF_REQUEST,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('TIMEOFF_REQUEST_ID')] = request_id;
    obj.postData.id = timeoff_id;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  clearCalendar() {
    const obj = {
      actionType: appConstants.ActionTypes.CLEAR_CALENDAR,
    };
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  bidOnDroppedShift(id, exchange_id) {
    const obj = {
      actionType: appConstants.ActionTypes.BID_ON_DROPPED_SHIFT,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('SHIFT_ID_PARAM')] = id;
    obj.postData[Utils.getEndpointParam('EXCHANGE_ID_PARAM')] = exchange_id;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  submitExchangeBid(bids, exchange_id) {
    const obj = {
      actionType: appConstants.ActionTypes.BID_ON_EXCHANGE,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('SHIFT_IDS_PARAM')] = bids;
    obj.postData[Utils.getEndpointParam('EXCHANGE_ID_PARAM')] = exchange_id;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  cancelExchangeOffer(exchange_id) {
    const obj = {
      actionType: appConstants.ActionTypes.DELETE_BIDS,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('EXCHANGE_ID_PARAM')] = exchange_id;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  acceptBidOffer(exchange_id, bid_id, user_id, shift_id, drop) {
    const obj = {
      actionType: appConstants.ActionTypes.ACCEPT_EXCHANGE_BID,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('EXCHANGE_ID_PARAM')] = exchange_id;
    obj.postData[Utils.getEndpointParam('BID_ID_PARAM')] = bid_id;
    obj.postData[Utils.getEndpointParam('USER_ID_PARAM')] = user_id;
    obj.postData[Utils.getEndpointParam('USER_ID_PARAM')] = user_id;
    obj.postData[Utils.getEndpointParam('SHIFT_ID_PARAM')] = shift_id;
    obj.postData.drop = drop;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
};
